import { Card } from "antd";
import Toggle from "../../../../components/common/toggle";
const Notifications = () => {
  return (
    <>
      <div className="px-3">
        <div>
          <div>
            <p className="text-lg font-medium tracking-wider">
              Allow App To Send And Receive Notifications
            </p>
            <Card className="">
              <p className="text-primaryPurple text-lg font-bold ml-2">
                Device
              </p>
              <Card className="border-0.5 border-gray-100 rounded-none">
                <div className="flex justify-between items-center">
                  <p className="font-medium ml-2 mr-2">Web Application</p>
                  <div className="mr-2">
                    <Toggle />
                  </div>
                </div>
              </Card>
              <div>
                <div className="flex justify-between items-center">
                  <p className="font-medium ml-2 mr-2">Mobile Application</p>
                  <div className="mr-2">
                    <Toggle />
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notifications;
